var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
var cls = classNames('contact-form');
import { ErrorList } from './error-list';
import { Field } from './field';
import { useForm } from '../../hooks/use-form';
import { FormLoader } from './form-loader';
import { Input } from './input';
import { Select } from './select';
import { TextArea } from './text-area';
import { usePage } from '../../hooks/use-page';
import { useReady } from '../../hooks/use-ready';
import { useLink } from '../../hooks/use-link';
import { onSubmitNetlifyForm } from '../../utils/on-submit-netlify-form';
import { useLang } from '../../hooks/use-lang';
import { DottedChevronDownIcon } from './dotted-chevron-down-icon';
import { InputCheckbox } from './input-checkbox';
import { Button } from './button';
import { useActiveLang } from '../../hooks/use-active-lang';
import { MarkdownContent } from './markdown-content';
import { MarkdownContentLinkTargetBlank } from './markdown-content-link';
import { useSiteRecaptchaKey } from '../../hooks/use-site-recaptcha-key';
import { useTermsPagePath } from '../../hooks/use-terms-page-path';
import { usePrivacyPolicyPagePath } from '../../hooks/use-privacy-page-path';
import { useSiteOwnerName } from '../../hooks/use-site-owner-name';
import EmailValidator from 'email-validator';
import { includes, trim, without } from 'lodash';
import ReCAPTCHA from 'react-google-recaptcha';
import validUrl from 'valid-url';
import { sprintf } from 'sprintf-js';
export var ContactFormDefaultProps = {
  showMembershipCheckbox: true,
  showSubscribeCheckbox: true,
  organisationTypes: [],
  typesRequired: true,
  typesLabel: 'What would you like to contact us about? (Required)',
  typesRequiredError: 'Please select the reason you are contacting us.',
  types: []
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FieldStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    align-self: stretch;\n    label {\n      color: ", ";\n    }\n  "], ["\n    align-self: stretch;\n    label {\n      color: ", ";\n    }\n  "])), theme.COLOR('text'))
});
var FormStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "], ["\n    padding-bottom: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "])), theme.UNIT(3))
});
var BaseInputStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border: 2px dotted ", ";\n    color: ", ";\n\n    &:focus {\n      outline: none;\n      border: 2px dotted ", ";\n    }\n\n    ", "\n  "], ["\n    border: 2px dotted ", ";\n    color: ", ";\n\n    &:focus {\n      outline: none;\n      border: 2px dotted ", ";\n    }\n\n    ", "\n  "])), theme.COLOR('secondary'), theme.COLOR('primary'), theme.COLOR('link-hover'), function (_a) {
    var hasError = _a.hasError;
    return hasError && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      outline: none;\n      border-color: red;\n    "], ["\n      outline: none;\n      border-color: red;\n    "])));
  })
});
var TextAreaStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 100%;\n    height: 150px;\n    padding: ", ";\n    ", ";\n  "], ["\n    width: 100%;\n    height: 150px;\n    padding: ", ";\n    ", ";\n  "])), theme.UNIT(4), BaseInputStyles)
});
var SelectStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 100%;\n    font-size: ", ";\n\n    .shp--select__control {\n      border: 2px dotted ", ";\n\n      &:hover {\n        border: 2px dotted ", ";\n      }\n    }\n  "], ["\n    width: 100%;\n    font-size: ", ";\n\n    .shp--select__control {\n      border: 2px dotted ", ";\n\n      &:hover {\n        border: 2px dotted ", ";\n      }\n    }\n  "])), theme.FONT_SIZE(14), theme.COLOR('secondary'), theme.COLOR('secondary'))
});
var InputStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 100%;\n    padding: ", ";\n    color: ", ";\n    ", ";\n  "], ["\n    width: 100%;\n    padding: ", ";\n    color: ", ";\n    ", ";\n  "])), theme.UNIT(4), theme.COLOR('primary'), BaseInputStyles)
});
var SubmitButtonStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["  \n    width: 200px;\n    margin-top: ", ";\n  "], ["  \n    width: 200px;\n    margin-top: ", ";\n  "])), theme.UNIT(8))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    background: none;\n    padding-bottom: ", ";\n  "], ["\n    background: none;\n    padding-bottom: ", ";\n  "])), theme.UNIT(100))
});
var ThankyouStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    padding: ", ";\n    width: 100%;\n    box-sizing: border-box;\n    flex-grow: 1;\n    color: ", ";\n    font-weight: 400;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n    text-align: center;\n    p {\n      margin: ", ";\n    }\n  "], ["\n    padding: ", ";\n    width: 100%;\n    box-sizing: border-box;\n    flex-grow: 1;\n    color: ", ";\n    font-weight: 400;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n    text-align: center;\n    p {\n      margin: ", ";\n    }\n  "])), theme.UNIT(2), theme.COLOR('text'), theme.UNIT(2))
});
var ThankyouMessageStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n    font-size: 1.25em;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n    font-size: 1.25em;\n  "])))
});
var IndicatorStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    width: 20px;\n    margin: 0 16px;\n  "], ["\n    width: 20px;\n    margin: 0 16px;\n  "])))
});
var InputCheckboxStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    color: ", ";\n    margin: ", " 0;\n    align-self: stretch;\n  "], ["\n    color: ", ";\n    margin: ", " 0;\n    align-self: stretch;\n  "])), theme.COLOR('text'), theme.UNIT(1))
});
var UpdatesStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", ";\n    margin-bottom: ", ";\n  "], ["\n    ", ";\n    margin-bottom: ", ";\n  "])), InputCheckboxStyles, theme.UNIT(8))
});
var TypeFieldStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TypeStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ErrorsStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    color: ", ";\n    padding: ", " ", " ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    font-weight: 500;\n    border: 2px dotted ", ";\n    font-size: ", ";\n\n    ul {\n      padding-left: ", ";\n    }\n\n    li {\n      margin: ", " 0; \n      padding-left: 0;\n    }\n  "], ["\n    color: ", ";\n    padding: ", " ", " ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    font-weight: 500;\n    border: 2px dotted ", ";\n    font-size: ", ";\n\n    ul {\n      padding-left: ", ";\n    }\n\n    li {\n      margin: ", " 0; \n      padding-left: 0;\n    }\n  "])), theme.COLOR('red'), theme.UNIT(6), theme.UNIT(6), theme.UNIT(7), theme.UNIT(4), theme.UNIT(4), theme.COLOR('red'), theme.FONT_SIZE(14), theme.UNIT(4), theme.UNIT(2))
}); // -------- Components -------->

var TYPE = 'type';
var MESSAGE = 'details';
var LINK = 'link';
var GIVEN_NAME = 'givenName';
var FAMILY_NAME = 'familyName';
var EMAIL = 'email';
var JOB_TITLE = 'jobTitle';
var COMPANY = 'company';
var ORGANISATION_TYPE = 'organisationType';
var URL = 'url';
var FORM_NAME = 'contact';
var AGREE = 'agree';
var BECOME_MEMBER = 'becomeAMember';
var RECEIVE_UPDATES = 'receiveUpdates';
var My = {
  Container: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Loader: styled(FormLoader)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Thankyou: styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ThankyouStyles),
  ThankyouMessage: styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ThankyouMessageStyles),
  Agree: styled(InputCheckbox).attrs({
    id: AGREE,
    name: AGREE
  })(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), InputCheckboxStyles),
  BecomeAMember: styled(InputCheckbox).attrs({
    id: BECOME_MEMBER
  })(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), InputCheckboxStyles),
  Updates: styled(InputCheckbox).attrs({
    id: RECEIVE_UPDATES
  })(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), UpdatesStyles),
  Indicator: styled(DottedChevronDownIcon)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), IndicatorStyles),
  Form: styled.form(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  TypeField: styled(Field).attrs({
    id: TYPE
  })(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), TypeFieldStyles),
  Type: styled(Select).attrs({
    id: TYPE,
    placeholder: 'Select'
  })(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), TypeStyles),
  GivenNameField: styled(Field).attrs({
    id: GIVEN_NAME
  })(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  GivenName: styled(Input).attrs({
    id: GIVEN_NAME,
    placeholder: ''
  })(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  FamilyNameField: styled(Field).attrs({
    id: FAMILY_NAME
  })(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  FamilyName: styled(Input).attrs({
    id: FAMILY_NAME,
    placeholder: ''
  })(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  MessageField: styled(Field).attrs({
    id: MESSAGE
  })(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Message: styled(TextArea).attrs({
    id: MESSAGE
  })(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), TextAreaStyles),
  EmailField: styled(Field).attrs({
    id: EMAIL
  })(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Email: styled(Input).attrs({
    id: EMAIL,
    placeholder: ''
  })(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  CompanyField: styled(Field).attrs({
    id: COMPANY
  })(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Company: styled(Input).attrs({
    id: COMPANY,
    placeholder: ''
  })(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  OrganisationTypeField: styled(Field).attrs({
    id: ORGANISATION_TYPE
  })(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  OrganisationType: styled(Select).attrs({
    id: ORGANISATION_TYPE,
    placeholder: 'Organisation Type'
  })(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  JobTitleField: styled(Field).attrs({
    id: JOB_TITLE
  })(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  JobTitle: styled(Input).attrs({
    id: JOB_TITLE,
    placeholder: ''
  })(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  UrlField: styled(Field).attrs({
    id: URL
  })(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Url: styled(Input).attrs({
    id: URL,
    placeholder: 'Company Website URL'
  })(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  Errors: styled(ErrorList)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), ErrorsStyles),
  SubmitButton: styled(Button)(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), SubmitButtonStyles)
};
export var ContactForm = function ContactForm(props) {
  var className = props.className,
      showMembershipCheckbox = props.showMembershipCheckbox,
      showSubscribeCheckbox = props.showSubscribeCheckbox,
      organisationTypes = props.organisationTypes,
      types = props.types,
      typesLabel = props.typesLabel,
      typesRequired = props.typesRequired,
      typesRequiredError = props.typesRequiredError;
  var form = useForm(FORM_NAME);
  var organisationTypeOptions = organisationTypes.length && organisationTypes.map(function (type) {
    return {
      label: type,
      value: type
    };
  });
  var typeOptions = types.length && types.map(function (type) {
    return {
      label: type,
      value: type
    };
  });
  var values = form.values,
      patchValues = form.patchValues;

  var _a = __read(useState(''), 2),
      token = _a[0],
      setToken = _a[1];

  var _b = __read(useState([]), 2),
      errors = _b[0],
      setErrors = _b[1];

  var _c = __read(useState([]), 2),
      errorFields = _c[0],
      setErrorFields = _c[1];

  var Link = useLink().Link;
  var t = useLang();
  var lang = useActiveLang();
  var page = usePage();

  var formState = __assign({}, values);

  var SITE_RECAPTCHA_KEY = useSiteRecaptchaKey();
  var TERMS_PAGE_PATH = useTermsPagePath();
  var SITE_OWNER_NAME = useSiteOwnerName();
  var PRIVACY_POLICY_PAGE_PATH = usePrivacyPolicyPagePath();
  var requiresAgreement = TERMS_PAGE_PATH || PRIVACY_POLICY_PAGE_PATH;

  var onChange = function onChange(name) {
    return function (value) {
      var _a;

      patchValues((_a = {}, _a[name] = value, _a));
      setErrors([]);
      setErrorFields(without(errorFields, name));
    };
  };

  var onSubmit = function onSubmit(event) {
    return __awaiter(void 0, void 0, void 0, function () {
      var e, ef, data, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            event.preventDefault();
            e = [];
            ef = [];

            if (!token) {
              errors.push(t("Please check the I'm not a robot checkbox to validate you are human"));
            }

            if (!!typeOptions.length && typesRequired && !formState[TYPE]) {
              e.push(t(typesRequiredError));
              ef.push(TYPE);
            }

            if (trim(formState[GIVEN_NAME]) === '') {
              e.push(t("Please enter your given name."));
              ef.push(GIVEN_NAME);
            }

            if (trim(formState[FAMILY_NAME]) === '') {
              e.push(t("Please enter your family name."));
              ef.push(FAMILY_NAME);
            }

            if (trim(formState[MESSAGE]) === '') {
              e.push(t("Please provide the details of your request in the Message field."));
              ef.push(MESSAGE);
            }

            if (trim(formState[EMAIL]) !== '' && !EmailValidator.validate(formState[EMAIL])) {
              e.push(t("Please check that your email address is VALID"));
              ef.push(EMAIL);
            }

            if (trim(formState[URL]) !== '' && !validUrl.isWebUri(formState[URL])) {
              e.push(t("Please provide a VALID URL in the Company Website URL field"));
              ef.push(URL);
            }

            if (requiresAgreement && trim(formState[AGREE]) === '') {
              e.push(t("Please confirm you agree with our terms and privacy policy"));
              ef.push(AGREE);
            }

            setErrorFields(ef);
            setErrors(e);

            if (e.length) {
              return [2
              /*return*/
              , false];
            }

            data = __assign(__assign({}, formState), {
              'g-recaptcha-response': token
            });

            if (props.beforeSubmit) {
              props.beforeSubmit();
            }

            ;
            form.startSubmit();
            return [4
            /*yield*/
            , onSubmitNetlifyForm(FORM_NAME, page.path, data)];

          case 1:
            response = _a.sent();
            console.log("FORM DATA", data);
            setToken('');
            form.endSubmit();

            if (props.afterSubmit) {
              props.afterSubmit();
            }

            ;
            return [2
            /*return*/
            , false];
        }
      });
    });
  };

  var onCaptchaChange = function onCaptchaChange(token) {
    setToken(token);
  };

  var isSubmitDisabled = !!(!token && SITE_RECAPTCHA_KEY || form.isSubmitting);
  var hasErrors = !!errors.length;
  var isReady = useReady().isReady;
  var agreeText = TERMS_PAGE_PATH && PRIVACY_POLICY_PAGE_PATH ? sprintf(t("I confirm that I have read and agree to the [terms](%s) and [privacy policy](%s) of %s."), TERMS_PAGE_PATH, PRIVACY_POLICY_PAGE_PATH, SITE_OWNER_NAME) : TERMS_PAGE_PATH ? sprintf(t("I confirm that I have read and agree to the [terms](%s) of %s."), TERMS_PAGE_PATH, SITE_OWNER_NAME) : sprintf(t("I confirm that I have read and agree to the [privacy policy](%s) of %s."), PRIVACY_POLICY_PAGE_PATH, SITE_OWNER_NAME);
  return React.createElement(My.Container, {
    className: className
  }, form.isSubmitting && React.createElement(My.Loader, {
    color: "primary"
  }, t("Please wait...")), !form.isSubmitting && (form.isSubmitted ? React.createElement(My.Thankyou, null, React.createElement(My.ThankyouMessage, null, React.createElement("p", null, t("Thankyou, your submission has been received.")), React.createElement("p", null, t('We will be in touch soon.')))) : React.createElement(My.Form, {
    name: FORM_NAME,
    onSubmit: onSubmit,
    method: "post",
    "data-netlify-recaptcha": "true",
    "data-netlify": "true"
  }, React.createElement("input", {
    type: "hidden",
    name: "form-name",
    value: FORM_NAME
  }), typeOptions.length && React.createElement(My.TypeField, {
    label: t(typesLabel)
  }, React.createElement(My.Type, {
    hasError: includes(errorFields, TYPE),
    onChange: onChange(TYPE),
    options: typeOptions,
    value: formState[TYPE] || '',
    borderStyle: "dotted"
  })), React.createElement(My.GivenNameField, {
    label: t('Given Name (Required):')
  }, React.createElement(My.GivenName, {
    hasError: includes(errorFields, GIVEN_NAME),
    onChange: onChange(GIVEN_NAME),
    value: formState[GIVEN_NAME] || ''
  })), React.createElement(My.FamilyNameField, {
    label: t('Family Name (Required):')
  }, React.createElement(My.FamilyName, {
    hasError: includes(errorFields, FAMILY_NAME),
    onChange: onChange(FAMILY_NAME),
    value: formState[FAMILY_NAME] || ''
  })), React.createElement(My.EmailField, {
    label: t('Email:')
  }, React.createElement(My.Email, {
    hasError: includes(errorFields, EMAIL),
    onChange: onChange(EMAIL),
    value: formState[EMAIL] || ''
  })), React.createElement(My.CompanyField, {
    label: t('Company:')
  }, React.createElement(My.Company, {
    hasError: includes(errorFields, COMPANY),
    onChange: onChange(COMPANY),
    value: formState[COMPANY] || ''
  })), organisationTypeOptions.length && React.createElement(My.OrganisationTypeField, {
    label: t('Organisation Type:')
  }, React.createElement(My.OrganisationType, {
    onChange: onChange(ORGANISATION_TYPE),
    options: organisationTypeOptions,
    value: formState[ORGANISATION_TYPE] || '',
    borderStyle: "dotted"
  })), React.createElement(My.JobTitleField, {
    label: t('Job Title:')
  }, React.createElement(My.JobTitle, {
    hasError: includes(errorFields, JOB_TITLE),
    onChange: onChange(JOB_TITLE),
    value: formState[JOB_TITLE] || ''
  })), React.createElement(My.MessageField, {
    label: t('Message:')
  }, React.createElement(My.Message, {
    hasError: includes(errorFields, MESSAGE),
    onChange: onChange(MESSAGE)
  }, formState[MESSAGE] || '')), requiresAgreement && React.createElement(My.Agree, {
    onChange: onChange(AGREE),
    valid: !includes(errorFields, AGREE),
    checked: formState[AGREE] === 'yes'
  }, React.createElement(MarkdownContent, {
    text: agreeText,
    embedComponents: {
      a: {
        component: MarkdownContentLinkTargetBlank
      }
    }
  })), showMembershipCheckbox && React.createElement(My.BecomeAMember, {
    label: sprintf(t('I would like to become a %s member'), SITE_OWNER_NAME),
    onChange: onChange(BECOME_MEMBER),
    checked: formState[BECOME_MEMBER] === 'yes'
  }), showSubscribeCheckbox && React.createElement(My.Updates, {
    label: sprintf(t("I'd like to receive updates from %s"), SITE_OWNER_NAME),
    name: "agree",
    onChange: onChange(RECEIVE_UPDATES),
    checked: formState[RECEIVE_UPDATES] === 'yes'
  }), SITE_RECAPTCHA_KEY && React.createElement(ReCAPTCHA, {
    sitekey: SITE_RECAPTCHA_KEY,
    onChange: onCaptchaChange
  }), hasErrors && React.createElement(My.Errors, {
    items: errors
  }, t('Sorry, we need a bit more information:')), React.createElement(My.SubmitButton, {
    type: "submit",
    disabled: isSubmitDisabled
  }, t('Submit')))));
};
ContactForm.defaultProps = ContactFormDefaultProps;
ContactForm.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47;